import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-tip"]
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "kbd kbd-sm" }

import { computed, ref } from "vue";
import { err } from "@/utils";
import { useBackendStore } from "@/stores";
import ModalConfirm from "@/components/utils/ModalConfirm.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfigDeleteButton',
  setup(__props) {

const backend = useBackendStore();

// Require user confirmation when deleting configuration
const showDeleteModal = ref(false);
const onDeleteModalDone = (confirmed: boolean) => {
  showDeleteModal.value = false;
  if (confirmed) backend.deleteCurrentConfig();
};

const error = computed(() => {
  if (backend.currentConfig == null) return null;
  if (!backend.userLoggedIn) {
    return "Log in to delete your configuration";
  }
  if (!backend.userIsOwner) {
    return "This configuration cannot be modified";
  }
  return null;
});

const tooltip = computed(() => {
  if (backend.currentConfig == null) return null;
  if (error.value != null) return err(error.value);
  return "Delete current configuration";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([tooltip.value != null ? 'tooltip' : '']),
    "data-tip": tooltip.value
  }, [
    _createElementVNode("button", {
      class: "btn btn-accent w-24",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showDeleteModal.value = true)),
      disabled: _unref(backend).currentConfig == null || error.value != null
    }, " Delete ", 8, _hoisted_2),
    (_unref(backend).currentConfig?.name != undefined)
      ? (_openBlock(), _createBlock(ModalConfirm, {
          key: 0,
          modelValue: showDeleteModal.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showDeleteModal).value = $event)),
          title: "Delete this configuration?",
          confirmName: "Delete",
          onDone: onDeleteModalDone
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, [
              _cache[2] || (_cache[2] = _createTextVNode(" Are you sure you want to delete configuration ")),
              _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(backend).currentConfig.name), 1),
              _cache[3] || (_cache[3] = _createTextVNode("? This action cannot be undone. "))
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})